import { Box, Modal, Typography } from '@mui/material';
import React from 'react';

interface ModalGuideProps {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}

const ModalGuide: React.FC<ModalGuideProps> = ({ modalOpen, setModalOpen }) => (
  <Modal
    open={modalOpen}
    onClose={() => setModalOpen(false)}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backdropFilter: 'blur(4px)',
    }}
  >
    <Box
      sx={{
        width: '60%',
        height: '45%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        textAlign: 'center',
      }}
    >
      <Typography id="modal-title" variant="h3" sx={{ mb: 2, textAlign: 'center' }}>
        Learn Hub Slides
      </Typography>
      <Typography id="modal-description" variant="subtitle1" sx={{ mb: 2 }}>
        The Learn Hub Slides feature allows you to create and manage your own version of
        the lesson slides.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {[
          {
            src: '/images/learn-hub-copy.png',
            alt: 'Learn Hub Copy',
            label: 'Create a copy',
          },
          {
            src: '/images/learn-hub-edit.png',
            alt: 'Learn Hub Edit',
            label: 'Edit your version',
          },
          {
            src: '/images/learn-hub-teach.png',
            alt: 'Learn Hub Teach',
            label: 'Teach your version',
          },
        ].map(({ src, alt, label }) => (
          <Box
            key={alt}
            sx={{
              width: '33%',
              textAlign: 'center',
              border: '1px solid #ccc',
              padding: '1rem',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '12rem',
                overflow: 'hidden',
              }}
            >
              <img
                src={src}
                alt={alt}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
            <Typography variant="body2" sx={{ mt: 1 }}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Modal>
);

export default ModalGuide;
